import { apiService } from "@/common/api.service.js";

export default {
  // Site metadata
  siteMetadata(site_code) {
    const endpoint = `/api/site-metadata/${site_code}/`;
    return apiService(endpoint);
  },

  // SQL formulas
  sqlFormulas(site_code) {
    const endpoint = `/api/sql-formulas/${site_code}/`;
    return apiService(endpoint);
  },
};
